import React from 'react'
import { Navigate } from 'react-router-dom'

const OfflineInvoicesPage: React.FC = () => {
  // Redirect to the list page
  return <Navigate to="/offline-invoices/list" replace />
}

export default OfflineInvoicesPage
